import { FetchLookupsResponse } from '@lib/api';

import { LookupsValue } from '../types';

export function getRestaurantNameFromLookupsResponse(
  lookupsResponse: FetchLookupsResponse,
): LookupsValue['restaurantName'] {
  if (lookupsResponse.restaurants.length === 0) {
    return null;
  }

  const { restaurantArName, restaurantEnName } = lookupsResponse.restaurants[0];
  return {
    ar: restaurantArName,
    en: restaurantEnName,
  };
}
